import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";

import DirectorDetailsForm from "./Director_Detail/directoryDetail";
import CompanyDetailsForm from "./Company_Detail/companyDetailPrimary";
import { current } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";

// Company Detail Component
const CompanyDetail = () => (
  <Box p={2}>
    <Typography variant="h6" gutterBottom>
      Company Detail
    </Typography>
    <Typography>
      This is where the company details will be displayed.
    </Typography>
  </Box>
);

// Director Detail Component
const DirectorDetail = () => (
  <Box p={2}>
    <Typography variant="h6" gutterBottom>
      Director Detail
    </Typography>
    <Typography>
      This is where the director details will be displayed.
    </Typography>
  </Box>
);

// Main Tab Component
export default function ClientProfile() {
  const [activeTab, setActiveTab] = useState(0);
  const limit = 1;

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const navigate = useNavigate();

  function MoveToNextTab() {
    if (activeTab >= limit) {
      navigate("/dashboard/home");
    } else {
      setActiveTab(activeTab + 1);
    }
  }

  function MoveToPreviousTab() {
    if (activeTab <= 0) {
      console.log("Reach the Limit of Below");
    } else {
      setActiveTab(activeTab - 1);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        width: "100%",
        maxHeight: "100%",
        padding: 2,

        overflowY: "auto",
        textAlign: "left",
        bgcolor: "#EDF2F9",
        // Custom scrollbar styles
        "&::-webkit-scrollbar": {
          width: "6px", // Width of the scrollbar
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1", // Track color
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888", // Thumb color
          borderRadius: "10px", // Optional rounded edges for the thumb
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555", // Thumb color on hover
        },
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        sx={{
          borderBottom: 0,
          paddingBottom: 1,

          bgcolor: "white",
          width: "100%",
          borderColor: "divider",
          "& .MuiTab-root": { textTransform: "none", fontWeight: "500" },
        }}
      >
        <Tab label="Company Detail" />
        <Tab label="Director Detail" />
      </Tabs>

      {/* Content Area */}
      <Box mt={2}>
        {activeTab === 0 && (
          <CompanyDetailsForm
            MoveToNextTab={MoveToNextTab}
            MoveToPreviousTab={MoveToPreviousTab}
          />
        )}
        {activeTab === 1 && (
          <DirectorDetailsForm
            MoveToNextTab={MoveToNextTab}
            MoveToPreviousTab={MoveToPreviousTab}
          />
        )}
      </Box>
    </Box>
  );
}
